import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import {
  Chart,
  Axis,
  Tooltip,
  Coord,
  Legend,
  Interval,
} from "bizcharts";
import DataSet from "@antv/data-set";
import { Box } from "@mui/system";

import DownloadButton from "../Common/DownloadButton";

const HorizontalBarChartWithNegative = (props) => {
  const [data, setData] = useState(undefined);

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
  readString(csv, {
    complete: (results, file) => {

      setData(
        results.data.sort((a, b) =>
          a[props.retained] < b[props.retained] ? 1 : -1
        )
      );
    },
    download: true,
    header: true,
    dynamicTyping: true,
    error: (error, file) => {
      console.log("Error while parsing:", error, file);
    },
  });
};


 useEffect(() => {
  handleReadString();
}, [csv]);

  const { DataView } = DataSet;
  const dv = new DataView();

  const transformedFields = props.fields;
  if (data) {
  dv.source(data)
    .transform({
      type: "fold",
      fields: transformedFields,
      key: "result",
      value: "value",
      retains: [props.retained],
    })
    .transform({
      type: "map",
      callback: (obj) => {
        const key = obj.result;
        let type;
        if (
          key === "Below LOQ" ||
          key === "Between LOQ and MRL" ||
          key === "Above MRL" ||
          key === "Below quantification limit %" ||
          key === "Between quantification limit and Legal Limit %" ||
          key === "Above Legal Limit %"
        ) {
          type = "a";
        } else if (key === "Non-compliant" || key === "Non-compliant %") {
          type = "b";
        } else {
          type = "c";
        }
        obj.type = type;
        return obj;
      },
    });
}


  const [canvas, setCanvas] = useState(undefined);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }

    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const scale = { value: { min: 0, max: 100 } };
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        sx={{ paddingRight: { xs: "40px", sm: "30px", md: "0px" } }}
      >
        {!isMobile && (
          <p
            className="titleChart"
            style={{
              fontFamily: "Roboto Condensed, sans-serif",
            }}
          >
            {props.title}
          </p>
        )}
        {isMobile && (
          <p
            className="titleChart"
            style={{
              fontFamily: "Roboto Condensed, sans-serif",
              marginBottom: ".8rem",
            }}
          >
            {props.title}
          </p>
        )}
        <Box marginRight={props.marginRight} alignItems="center">
          <DownloadButton
            canvas={canvas}
            fileName={props.title}
            csv={data}
            isRaw
          />
        </Box>
      </Box>
      <Chart
        padding={props.padding}
        data={dv.rows}
        onGetG2Instance={(chartInstance) => {
          setTimeout(() => {
            setCanvas(chartInstance.canvas);
          }, 1000);
        }}
        height={props.height}
        scale={scale}
        autoFit
        tooltip={{}}
      >
        <Axis
          name="value"
          label={{
            formatter: function (val) {
              return val + "%";
            },
          }}
        />
        <Legend position="right" />
        <Tooltip
          shared
          itemTpl={
            '<li data-index={index} class="g2-tooltip-list-item" style="margin-bottom:3px;">' +
            '<span style="background-color:{color};width:10px;border-radius:50%;height:10px;display:inline-block;margin-right:8px;"></span>' +
            "{name}: {value}" +
            "</li>"
          }
          containerTpl={
            '<div class="g2-tooltip"  id="tooltipWrap" >' +
            '<div class="g2-tooltip-title" id="tooltipTitle" style="font-weight:bold;font-size:medium;color:#22294d;">  </div>' +
            '<ul class="g2-tooltip-list " style="color:#22294d;"></ul>' +
            "</div>"
          }
        />
        <Coord transpose={!isMobile} />
        <Interval
          position={`${props.retained}*value`}
          color={[
            "result",
            function (result) {
              return props.colorMap[result];
            },
          ]}
          tooltip={[
            "result*value",
            (result, value) => {
              return {
                name: result,
                value: Math.round(value * 10) / 10 + "%",
              };
            },
          ]}
          adjust={[
            {
              type: "dodge",
              dodgeBy: "type",
              marginRatio: 0,
            },
            {
              type: "stack",
            },
          ]}
        />
        <Legend flipPage={false} />
        {!isMobile && (
          <Axis
            name={props.retained}
            label={{
              style: {
                margin: "50px",
                padding: "50px",
                textAlign: "end",
                fontSize: 12,
                textBaseline: "top",
                fontFamily: "Roboto Condensed, sans-serif",
              },
            }}
          />
        )}
        {isMobile && (
          <Axis
            name={props.retained}
            verticalFactor={-1}
            label={{
              autoHide: false,
              rotate: 200,
              offset: 10,
              style: {
                textAlign: "end",
                fill: "#404040",
                fontSize: 12,
                textBaseline: "top",
                fontFamily: "Roboto Condensed, sans-serif",
              },
            }}
          />
        )}
      </Chart>

    </Box>
  );
};

export default HorizontalBarChartWithNegative;
